import type React from 'react';

import { Skeleton, Tooltip, Typography } from '@cobliteam/ui/components';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import { useSummary } from './SummaryVehicleMedia';

type SummaryData = 'licensePlate' | 'vehicleGroup' | 'dateTime' | 'custom' | 'driver';

interface SummaryVehicleMediaItemProps {
  type?: SummaryData;
  iconName?: IconNames;
  label?: string;
  dataTestId?: string;
}

const defaults: { [key in SummaryData]: { iconName: IconNames; label: string } } = {
  custom: {
    label: 'Data e hora',
    iconName: 'calendar-days',
  },
  dateTime: {
    label: 'Data e hora',
    iconName: 'calendar-days',
  },
  licensePlate: {
    label: 'Veículo',
    iconName: 'car-front',
  },
  vehicleGroup: {
    label: 'Grupo',
    iconName: 'cb-filters-vehicle-group-cb',
  },
  driver: {
    label: 'Motorista',
    iconName: 'cb-filters-driver-cb',
  },
};

const SummaryVehicleMediaItem = ({ type = 'custom', children, ...props }: React.PropsWithChildren<SummaryVehicleMediaItemProps>) => {
  const { isLoading, textVariant } = useSummary();

  const label = props.label ?? defaults[type].label;
  const iconName = props.iconName ?? defaults[type].iconName;

  if (!isLoading && children === undefined) return null;

  return (
    <Tooltip content={label} arrow position='top'>
      <div className='flex cursor-default items-center gap-2'>
        <Icon name={iconName} color='gray-dark' className='shrink-0' />
        {isLoading ? (
          <Skeleton className='h-5 w-16 bg-gray-5' />
        ) : (
          <Typography data-testid={props.dataTestId} variant={textVariant} color='secondary' className='text-nowrap'>
            {children}
          </Typography>
        )}
      </div>
    </Tooltip>
  );
};

export default SummaryVehicleMediaItem;
